import type { FC } from "react"
import React, { useEffect } from "react"
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react"

import { useAddress } from "web3/hooks/useAddress"
import WalletSelectionModal from "web3/components/WalletSelectionModal"
import PreCheckNetworkSelection from "web3/components/PreCheckNetworkSelection"
import type { ChainId } from "query/graphql"
import { useChainReference } from "web3/hooks/useChainReference"
import type { Chain } from "web3/hooks/useMultichainAccount"

type Props = {
  isCorrectNetwork: boolean
  isMultiChain?: boolean
  chainId: ChainId
  isOpen: boolean
  walletType?: Chain
  onClose: () => void
  onValid: () => void
}

const PreCheckModal: FC<Props> = ({
  isCorrectNetwork,
  chainId,
  onValid,
  onClose,
  isOpen,
  walletType,
}) => {
  const chainReference = useChainReference()
  const address = useAddress()

  const isDisplayWalletSelection = !address

  const isDisplayNetworkSelection =
    !isDisplayWalletSelection && chainReference && !isCorrectNetwork

  useEffect(() => {
    if (!isDisplayWalletSelection && !isDisplayNetworkSelection && isOpen) {
      onClose()
      onValid()
    }
  }, [
    isDisplayNetworkSelection,
    isDisplayWalletSelection,
    isOpen,
    onClose,
    onValid,
  ])

  if (isDisplayWalletSelection) {
    return (
      <WalletSelectionModal
        isOpen={isOpen}
        walletType={walletType}
        onClose={onClose}
      />
    )
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxWidth={408} pb={6}>
        <ModalHeader
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          textStyle="h5"
        >
          {isDisplayWalletSelection ? "Connect Wallet" : "Select Network"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody mt={5}>
          {isDisplayNetworkSelection ? (
            <PreCheckNetworkSelection
              chainReference={chainReference}
              requiredChainId={chainId}
            />
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default PreCheckModal
